import React from "react";
import logo from "../../assets/images/svg/logo.svg";
import ButtonPrimary from "../buttons/ButtonPrimary";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-scroll"; // import Link from react-scroll

function Header() {
  const navItems = [
    { label: "OUR APPROACH", target: "our-approach" },
    { label: "WHY GEESEZ", target: "why-geesez" },
    { label: "CONTACT", target: "contact" },
  ];

  return (
    <div className="w-100 bg-transparent">
      <Navbar expand="lg" className=" py-3 bg-theme-secondary " bg="transparent" data-bs-theme="dark" fixed="top">
        <Container>
          <Navbar.Brand href="#">
            <img alt="Vector" src={logo} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="mx-auto my-2 my-lg-0 gap-5"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.target}
                  spy={true}
                  smooth={true}
                  offset={-70} // adjust for navbar height
                  duration={100}
                  className="poppins-medium text-transform-uppercase font-13 letter-spacing-2 text-white"
                  style={{ cursor: "pointer" }}
                >
                  {item.label}
                </Link>
              ))}
            </Nav>
            <Form className="d-flex">
              <ButtonPrimary text="Get started" target='contact'/>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}


export default Header;
